<template>
    <div class="animated fadeIn gofixTables" v-bind:class="{'run-loading':actionStatus.listLoading}">
        <slot name="gofix_table:before-control"></slot>
        <b-row v-if="tableControls.reload ||
        tableControls.create ||
        tableControls.delete ||
        tableControls.createPWO ||
        tableControls.enable ||
        tableControls.assign ||
        tableControls.changeStatus ||
        tableControls.allItems ||
        tableControls.tablePagination ||
        tableControls.tableImport ||
        tableControls.tableExport ||
        tableControls.tableColumnSettings ||
        tableControls.tableCloneMaster
">
            <b-col :md="tableSettings.leftWidth">
                <div class="dataControls">
                    <ul class="controlList">
                        <slot name="gofix_table:before-control-left"></slot>
                        <li class="control-item" v-if="tableControls.reload">
                            <a class="control-item-link cursor-pointer" @click="reloadTableItems" title="Refresh" v-b-tooltip.hover><img src="img/reLoad.png" alt="Refresh"></a>
                        </li>
                        <li class="control-item" v-if="tableControls.create">
                            <a class="control-item-link cursor-pointer" @click="createNewTableItem" :title="tableControls.createTooptip" v-b-tooltip.hover><img src="img/blankIcon.png" :alt="tableControls.createTooptip"></a>
                        </li>
                        <slot name="gofix_table:after-btn-create"></slot>
                        <li class="control-item" v-if="tableControls.tableCloneMaster">
                            <a class="control-item-link cursor-pointer" @click="cloneMaster" title="Clone" v-b-tooltip.hover><img :src="tableControls.tableCloneMasterIcon" alt="Clone"></a>
                        </li>
                        <li class="control-item" v-if="tableControls.delete && tableSelected.selected.length">
                            <a class="control-item-link cursor-pointer" @click="deleteTableItemsComfirm" title="Delete" v-b-tooltip.hover><img src="img/deleteIcon.png" alt="Delete"></a>
                        </li>
                        <li class="control-item" v-if="tableControls.createPWO  && tableSelected.selected.length">
                            <a class="control-item-link cursor-pointer" @click="createPWOComfirm" title="Create PWO" v-b-tooltip.hover><img src="img/ant-design_file-add-outline.png" alt="Create PWO"></a>
                        </li>
                        <li class="control-item" v-if="tableControls.enable  && tableSelected.selected.length">
                            <a class="control-item-link cursor-pointer" @click="enableItems" title="Enable" v-b-tooltip.hover><img src="img/checkIcon.png" alt="Enable"></a>
                        </li>
                        <li class="control-item" v-if="tableControls.adjustment  && tableSelected.selected.length">
                            <a class="control-item-link cursor-pointer" @click="adjustmentItems" title="Adjustment" v-b-tooltip.hover><img src="img/price.png" alt="Enable"></a>
                        </li>
                        <li class="control-item" v-if="(tableControls.assign || tableControls.changeStatus) && tableSelected.selected.length">
                            <b-dropdown class="btn" left v-b-tooltip.hover title="Option">
                                <b-dropdown-item v-if="tableControls.assign" @click="assignItems">Assign to</b-dropdown-item>
                                <b-dropdown-item v-if="tableControls.changeStatus" @click="editStatusItemsComfirm">Edit Status</b-dropdown-item>
                            </b-dropdown>
                        </li>
                        <slot name="gofix_table:after-control-left"></slot>
                    </ul>
                </div>
            </b-col>
            <b-col :md="tableSettings.rightWidth">
                <div class="tableControls">
                    <slot name="gofix_table:before-control-right"></slot>
                    <div class="tableSelected" v-if="tableSelected.allSelected && tableControls.allItems && tableSettings.total > tableRequest.limit">
                        <p class="mb-0">
                            All {{tableSelected.allItems ? tableSettings.total : tableSelected.selected.length}} items on this page are selected
                            <span @click="tableSelected.allItems = true" v-if="!tableSelected.allItems"> Select all {{tableSettings.total}} items</span>
                        </p>
                    </div>
                    <div class="tableSendSelected mr-4" v-if="tableControls.sendSelected ">
                        <gofix-button :label="tableControls.sendSelectedText" @click="sendSelectedData" outline></gofix-button>
                    </div>
                    <div class="tablePagination" v-if="tableControls.tablePagination">
                        <div class="pageCount">
                            {{tableSettings.total === 0 ? 0 : ((tableRequest.page - 1) * tableRequest.limit) + 1}} - {{(tableRequest.page * tableRequest.limit) > tableSettings.total ? tableSettings.total : (tableRequest.page * tableRequest.limit) }} of {{tableSettings.total}}
                        </div>
                        <div class="pageControls">
                            <span class="prev" @click="prevPage" title="Previous page" v-bind:class="{'disabled-button': tableRequest.page <= 1}" v-b-tooltip.hover>
                                <svg width="6" height="10" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.29344 0.293762C6.68344 0.683762 6.68344 1.31376 6.29344 1.70376L2.41344 5.58376L6.29344 9.46376C6.68344 9.85376 6.68344 10.4838 6.29344 10.8738C5.90344 11.2638 5.27344 11.2638 4.88344 10.8738L0.293437 6.28376C-0.0965624 5.89376 -0.0965624 5.26376 0.293437 4.87376L4.88344 0.283762C5.26344 -0.0962378 5.90344 -0.0962378 6.29344 0.293762Z" fill="black" fill-opacity="0.54"></path>
                                </svg>
                            </span>
                            <span class="next" @click="nextPage" title="Next page" v-bind:class="{'disabled-button':tableRequest.page >= tableSettings.totalPage}" v-b-tooltip.hover>
                                <svg width="6" height="10" viewBox="0 0 5 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.2925 0.293762C-0.0975 0.683762 -0.0975 1.31376 0.2925 1.70376L4.1725 5.58376L0.2925 9.46376C-0.0975 9.85376 -0.0975 10.4838 0.2925 10.8738C0.6825 11.2638 1.3125 11.2638 1.7025 10.8738L6.2925 6.28376C6.6825 5.89376 6.6825 5.26376 6.2925 4.87376L1.7025 0.283762C1.3225 -0.0962378 0.6825 -0.0962378 0.2925 0.293762Z" fill="black" fill-opacity="0.54">
                                    </path>
                                </svg>
                            </span>
                        </div>
                        <div class="pageLimit">
                            <gofix-form-dropdown
                                    label=""
                                    class="gofixInputMinWith gofixDropdownBorder gofixInputNoBg gofixDropdownLimit m-0"
                                    :options="[25,50,100,150,200,500]"
                                    :filterable="false"
                                    :clearable="false"
                                    :searchable="false"
                                    v-model="tableRequest.limit"
                            >
                            </gofix-form-dropdown>
                        </div>
                    </div>
                    <div class="tableFilter" v-bind:class="{active:actionStatus.showFilter}" v-if="tableControls.tableFilter">
                        <span class="filter" title="Filter" v-b-tooltip.hover @click="actionStatus.showFilter = !actionStatus.showFilter">
                            <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.30512 13H12.7496V10.8333H8.30512V13ZM0.527344 0V2.16667H20.5273V0H0.527344ZM3.86068 7.58333H17.194V5.41667H3.86068V7.58333Z" fill="#999999"/>
                            </svg>
                        </span>
                    </div>
                    <div class="tableSettings" v-if="tableControls.tableImport || tableControls.tableExport || tableControls.tableColumnSettings">
                        <b-dropdown right>
                            <b-dropdown-item v-if="tableControls.tableImport" @click="actionStatus.modals.import.open = true">Import</b-dropdown-item>
                            <b-dropdown-item v-if="tableControls.tableExport" @click="exportCsv" href="#">Export</b-dropdown-item>
                            <b-dropdown-item v-if="tableControls.tableColumnSettings" @click="actionStatus.modals.columnSetting.open = true" href="#">Column Setting</b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <slot name="gofix_table:after-control-right"></slot>
                </div>
            </b-col>
        </b-row>
        <slot name="gofix_table:after-control"></slot>
        <vue-scrollbar :class="['tableList', {'fixed-scrollbar': isFixedScrollbar}, {showFilter:actionStatus.showFilter}]" ref="scrollbar">
            <b-table :items="tableItems"
                 :fields="tableFields.show"
                 @head-clicked="tableHeaderClick"
                 @row-clicked="tableItemRowClick"
                 :tbodyTrClass="tbodyTrClass" fixed>

            <!-- Filter fields -->
            <template slot="top-row" slot-scope="row" v-if="tableControls.tableFilter">
                <FilterTable :columns="row" :filter="tableRequest.filter" :search="search" :data-select="tableSettings.dataSelect"></FilterTable>
            </template>

            <!--Header render-->
            <template :slot="'HEAD_' + field.key" v-if="field.key !== 'actions'" slot-scope="data" v-for="field in tableFields.show">
                {{data.label}}
                <span class="icon-sorting" v-if="field.sorting">
                    <i class="fa fa-caret-up icons font-xs" v-bind:class="{active : tableRequest.sortColumn === data.column && tableRequest.sortDirection === 'DESC'}"></i>
                    <i class="fa fa-caret-down down icons font-xs" v-bind:class="{active : tableRequest.sortColumn === data.column && tableRequest.sortDirection === 'ASC'}"></i>
                </span>
            </template>

            <!--Slot custom table-->
            <template :slot="field.key" v-if="field.key !== 'actions'" slot-scope="data" v-for="field in tableFields.show">
                <slot :name="`gofix_table:${field.key}`" v-bind:item="data.item" v-bind:index="data.index">{{data.item | fieldVal(field.key)}}</slot>
            </template>

            <!-- Default checkbox -->
            <template slot="HEAD_actions" slot-scope="foo">
                <b-form-checkbox class="uniform" v-model="tableSelected.allSelected" @change="selectAllItems"></b-form-checkbox>
            </template>
            <template slot="actions" slot-scope="row">
                <slot name="gofix_table:before-actions" v-bind:item="row.item" v-bind:index="row.index"></slot>
                <slot name="gofix_table:actions" v-bind="row" >
                    <b-form-checkbox v-if="['joblist','case-management','payment-line-item-source', 'client-contract-asset-management', 'budget-entries', 'property-versioning','table-incoming-documents','table-incoming-documents-detail'].indexOf(tableSettings.name) < 0" :value="row.item.id" v-model="tableSelected.selected"></b-form-checkbox>
                    <b-form-checkbox v-if="tableSettings.name === 'joblist'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.order_id != null"></b-form-checkbox>
                    <b-form-checkbox v-if="tableSettings.name === 'case-management'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.work_order_id != null"></b-form-checkbox>
                    <b-form-checkbox v-if="tableSettings.name === 'payment-line-item-source'" :value="row.item.payment_voucher != null ? 0:row.item.id" v-model="tableSelected.selected" :disabled="row.item.payment_voucher != null"></b-form-checkbox>
                    <b-form-checkbox v-if="tableSettings.name === 'client-contract-asset-management'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.coming_job != null"></b-form-checkbox>
                    <b-form-checkbox v-if="tableSettings.name === 'budget-entries'" :value="row.item" v-model="tableSelected.selected"></b-form-checkbox>
                    <b-form-checkbox v-if="tableSettings.name === 'property-versioning'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.is_current"></b-form-checkbox>
                    <b-form-checkbox v-if="tableSettings.name === 'table-incoming-documents'" :value="row.item.incoming_document_id" v-model="tableSelected.selected"></b-form-checkbox>
                    <b-form-checkbox v-if="tableSettings.name === 'table-incoming-documents-detail'" :value="row.item.incoming_document_id" v-model="tableSelected.selected"></b-form-checkbox>
                </slot>
            </template>

            <!-- bottom row -->
            <template slot="bottom-row" slot-scope="data">
                <slot :name="`gofix_table:bottom-row`" v-bind:data="data"></slot>
            </template>

            </b-table>
        </vue-scrollbar>

        <!--  --------------------------------  Modals HTML ------------------------------------   -->
        <!--Setting Columns-->
        <b-modal :no-close-on-backdrop="true" id="modal-Columns"
                 :title="actionStatus.modals.columnSetting.resizeColumn ? 'Column Width (px)' : 'Column Setting'"
                 v-model="actionStatus.modals.columnSetting.open"
                 hide-footer :centered="true"
                 @hidden="resetColumnFieldsSetting"
        >

            <div v-bind:class="{'run-loading' : actionStatus.modals.columnSetting.loading}">
                <div v-if="actionStatus.modals.columnSetting.resizeColumn" class="columnsShow">
                    <ul>
                        <template v-for="(item, index) in tableFields._show">
                            <li v-if="item.key !== 'actions'" :key="index">
                                <gofix-form-input-number
                                        :label="item.label"
                                        v-model="item.width"
                                        :integer-limit="6"
                                        :include-thousands-separator="false"
                                        :allowDecimal="false"
                                ></gofix-form-input-number>
                            </li>
                        </template>
                    </ul>
                </div>
                <div v-if="!actionStatus.modals.columnSetting.resizeColumn" class="columnsShow">
                    <ul>
                        <draggable v-model="tableFields._show" >
                            <template v-for="(item, index) in tableFields._show">
                                <li v-if="item.key !== 'actions'" :key="index">
                                    <gofix-button :label="item.label" @click="hiddenField(item,index)">
                                        <template slot="gofix:button:beforeLabel"><span class="closeIcon"></span></template>
                                    </gofix-button>
                                </li>
                            </template>
                        </draggable>
                    </ul>
                </div>
                <div v-if="!actionStatus.modals.columnSetting.resizeColumn" class="columnsHide">
                    <ul>
                        <draggable v-model="tableFields._hide">
                            <li v-for="(item,index) in tableFields._hide" :key="index">
                                <gofix-button :label="item.label" @click="shownField(item,index)" outline>
                                    <template slot="gofix:button:beforeLabel"><span class="closeIcon"></span></template>
                                </gofix-button>
                            </li>
                        </draggable>
                    </ul>
                </div>
                <b-button-group class="d-block text-right pr-3">
                    <gofix-button v-if="!actionStatus.modals.columnSetting.resizeColumn" label="EDIT COLUMN WIDTH" @click="linkToEditColumnWith" noBorder dark></gofix-button>
                    <gofix-button v-else label="CANCEL" @click="resetColumnFieldsSetting" noBorder dark></gofix-button>
                    <gofix-button :label="actionStatus.modals.columnSetting.resizeColumn ? 'APPLY' : 'SUBMIT'" @click="saveColumnSettingWithUser" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
        <!--Enable Comfirm-->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="actionStatus.modals.createPWO.open">
            <div class="center">Are you sure you want to<br/>create <strong>PWO</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="actionStatus.modals.createPWO.open = false">No</b-button>
                <b-button class="custom-btn" :disabled="actionStatus.modals.createPWO.loading" @click="createPWO" > <b-spinner v-if="actionStatus.modals.createPWO.loading" small type="grow"></b-spinner> Yes</b-button>
            </b-button-group>
        </b-modal>
        <!--Change Status-->
        <b-modal :no-close-on-backdrop="true" id="modalChangeStatus" title="Edit Status" hide-footer :centered="true" v-model="actionStatus.modals.changeStatus.open">
            <b-form class="pb-20"  v-bind:class="{'run-loading':actionStatus.modals.changeStatus.loading}">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                                label="Choose Status"
                                :filterable="false"
                                :required="true"
                                v-model="actionStatus.modals.changeStatus.status"
                                :options="actionStatus.modals.changeStatus.data">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="editStatusItems" :loading="actionStatus.modals.changeStatus.loading"  noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!--Import data-->
        <b-modal :no-close-on-backdrop="true" @hide="resetImport" title="import file" id="modal-Import" hide-footer v-model="actionStatus.modals.import.open">
            <b-form>
                <b-form-group>
                    <b-form-file @input="changeFile" placeholder="Click Browse to upload file" :state="actionStatus.modals.import.check" ref="file-input" accept=".csv" v-model="actionStatus.modals.import.file" >
                        <template slot="file-name" slot-scope="{ names }">
                            <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group>
                <slot :name="`gofix_table:import-content`"></slot>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="importItems" :loading="actionStatus.modals.import.loading"  noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <!--Delete items-->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="actionStatus.modals.delete.open">
            <div class="center">
                Are you sure you want to<br/>delete <strong>This Item</strong>?
                <slot name="gofix_table:modal-remove-desc"></slot>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="actionStatus.modals.delete.open = false">No</b-button>
                <b-button class="custom-btn" @click="deleteTableItems" :disabled="actionStatus.modals.delete.loading">
                    <b-spinner v-if="actionStatus.modals.delete.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    const FilterTable = () => import('../partial/FilterTableV2')
    import draggable from 'vuedraggable';
    export default {
        name: 'goFixTables',
        props: {
            settings: {
                type: Object,
                default: null
            },
            tableItems: {
                type: Array,
                default: []
            },
            tbodyTrClass: {
                type: [String, Array, Function],
                default: null
            },
            isFixedScrollbar: {
                type: Boolean,
                default: true
            },
        },
        components: {
            FilterTable,
            draggable
        },
        computed: {
            ...mapGetters({
                userLogged: "AuthController/user",
                contractSelector: 'ContractController/ClientContractID',
                HeaderItem: 'BudgetAllocationController/headerItem',
            }),
          tableControls: function () {
            return  Object.assign({},this.constValue.controls, this.settings.controls);
          },
        },
        data: () => {
            return {
                constValue:{
                    limit: [1,25,50,100,500],
                    controls:{
                        reload: true,
                        create: true,
                        createTooptip: "New",
                        delete: true,
                        createPWO: false,
                        enable: false,
                        assign: false,
                        changeStatus: false,
                        allItems: false,
                        adjustment: false,
                        sendSelected: false,
                        sendSelectedText: "Save",
                        tableFilter:true,
                        tableImport:true,
                        tableExport:true,
                        tableCloneMaster:false,
                        tableCloneMasterIcon: 'img/clone.png',
                        tableColumnSettings:true,
                        tablePagination:true,

                    },
                    leftWidth: 3,
                    rightWidth: 9
                },
                actionStatus:{
                    showFilter: false,
                    listLoading: false,
                    modals: {
                        columnSetting:{
                            open: false,
                            resizeColumn: false,
                            loading: false
                        },
                        createPWO : {
                            open: false,
                            loading: false
                        },
                        changeStatus : {
                            open: false,
                            loading: false,
                            status: null,
                            data: ["Planned","Due","Started","Completed","Verified","Expired","Cancelled"],
                        },
                        import:{
                            open: false,
                            loading: false,
                            file: null,
                            fileName: "Click Browse to upload file"
                        },
                        delete: {
                            open: false,
                            loading: false
                        }
                    }
                },
                tableSettings: {
                    totalPage : 1,
                    total : 0,
                    leftWidth: 3,
                    rightWidth: 9
                },
                tableFields: {
                    fields : [],
                    show : [],
                    hide : [],
                    _show : [],
                    _hide : [],
                },
                tableRequest:{
                    filter:null,
                    limit:25,
                    page:1,
                    isCMS: 1,
                    sortColumn: null,
                    sortDirection: null,
                    useDatabaseView: false
                },
                tableSelected : {
                    allSelected : false,
                    selected : [],
                    allItems:false
                }
            }
        },
        filters:{
            fieldVal: function(value,key) {
                if(!key) return '';
                let key_tmp = key.split(".");
                if(key_tmp.length > 1){
                    let objData = value;
                    for (let i = 0 ; i < key_tmp.length; i++){
                        objData = (objData && objData[key_tmp[i]]) ? objData[key_tmp[i]] : null;
                        if(objData === null) return null;
                    }
                    return objData;
                }
                return value[key];
            }
        },
        created() {
            //Merge settings
            let tableSettings = Object.assign(this.tableSettings,this.settings);
            tableSettings.controls = Object.assign(this.constValue.controls,this.settings.controls);
            this.tableSettings = JSON.parse(JSON.stringify(tableSettings));
            this.tableSettings.totalPage = Math.ceil(this.tableSettings.total / this.tableRequest.limit);

            //Merge filter
            this.tableRequest.filter = JSON.parse(JSON.stringify(this.settings.filter));
            if(!['performance-assesment-contract-sum', 'performance-assesment-performance-computation', 'performance-assesment-maintenance-weight', 'performance-assesment-other-sources-weightage', 'performance-assesment-lump-sum-payment'].includes(this.tableSettings.name)) {
                if(this.tableRequest.filter.contract_id){
                    this.tableRequest.filter.contract_id.value = (this.contractSelector && this.contractSelector.id) ? this.contractSelector.id : null;
                }
                if(this.tableRequest.filter.client_contract_id){
                    this.tableRequest.filter.client_contract_id.value = (this.contractSelector && this.contractSelector.id) ? this.contractSelector.id : null;
                }
                if(this.tableRequest.filter.contract_term_id){
                    this.tableRequest.filter.contract_term_id.value = (this.contractSelector.contract_terms && this.contractSelector.contract_terms[0]) ? this.contractSelector.contract_terms[0].id : null;
                }
            }

            //Merge sorting
            this.tableRequest.sortColumn = this.settings.sortColumn || null;
            this.tableRequest.sortDirection = this.settings.sortDirection ? this.settings.sortDirection.toUpperCase() : null;

            //Merge use Database view
            this.tableRequest.useDatabaseView = this.settings.useDatabaseView || null;
            this.tableRequest.isCMS = (this.settings.isCMS >= 0) ? this.settings.isCMS : 1;

            //Load table config by user
            this.getColumnSettingByUser();

            //Get table data
            this.getTableData(true);
        },
        watch:{
            userLogged: function(val, old) {
                if(val && val.id) {
                    this.getColumnSettingByUser();
                }
            },
            contractSelector: function(val, old) {
                if(['performance-assesment-contract-sum', 'performance-assesment-performance-computation', 'performance-assesment-maintenance-weight', 'performance-assesment-other-sources-weightage', 'performance-assesment-lump-sum-payment'].includes(this.tableSettings.name)) return;
                if(this.tableRequest.filter.contract_id || this.tableRequest.filter.client_contract_id || this.tableRequest.filter.contract_term_id){
                    this.reloadTableItems();
                }
            },
            "settings.total" : function(val){
                this.tableSettings.total = val;
                this.tableSettings.totalPage =  Math.ceil(val/ this.tableRequest.limit)
            },
            "settings.itemSelected" : function(val){
                this.tableSelected.selected = val;
            },
            "tableRequest.page" : function(val){
                this.getTableData();
            },
            "tableRequest.limit" : function(val){
                if(this.tableRequest.page === 1){
                    this.getTableData();
                }else{
                    this.tableRequest.page = 1;
                }
            },
            "tableSelected.allSelected": function(val, old) {
                this.tableSelected.allItems = false;
            },
            "tableSelected.selected": function(val, old) {
                if(this.isReload)  {
                    this.isReload = false
                    return this.allSelected = false;
                }
                //let arr = this.Items.data.filter(item => item.order_id == null)
                if(this.tableSelected.selected.length > 0 && this.tableItems.length === this.tableSelected.selected.length) {
                    this.tableSelected.allSelected = true;
                }else{
                    this.tableSelected.allSelected = false;
                }

                this.$emit('change-selected', val);
            },
            "actionStatus.modals.import.file": function(val, old) {
                if (val) {
                    let arrExtionsionAccept = ['csv']
                    let extension = val.name.split('.')[1].toLowerCase();
                    if(!arrExtionsionAccept.includes(extension)) {
                        this.$refs['file-input'].reset();
                        return this.$bvToast.toast('File format is incorrect. Please select a .csv file!', {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'primary',
                            solid: true
                        })
                    }
                    return this.actionStatus.modals.import.fileName = val.name;
                }
                return this.actionStatus.modals.import.fileName = 'Click Browse to upload file'
            },
        },
        methods:{
            updateDataSelect(){
                this.tableSettings.dataSelect = Object.assign(this.tableSettings.dataSelect, this.settings.dataSelect)
            },
            updateDeletedBT(){
                this.tableSettings.controls.delete = this.settings.controls.delete
            },
            search(){
                if(this.tableSettings.name != "budget-entries") {
                    let values = {};
                    for (const [key, val] of Object.entries(this.tableRequest.filter)) {
                        if (val && 
                            !['client_contract_id', 'contract_id', 'work_item_id', 'work_item_type', 'folder_id'].includes(key)
                            && val.type && val.function && (
                            (Array.isArray(val.value) && val.value.length) || (!Array.isArray(val.value) && val.value)
                            )
                        )
                        values[key] = {
                            function: val.function,
                            value: val.value,
                        }
                    }

                    if(Object.keys(values).length) localStorage.setItem(this.tableSettings.name, JSON.stringify(values));
                    else localStorage.removeItem(this.tableSettings.name);
                }

                if(this.tableRequest.page === 1){
                    this.getTableData();
                }else{
                    this.tableRequest.page = 1;
                }
            },
            getTableData(is_load_filter = false){
                this.actionStatus.listLoading = true;
                if(is_load_filter && localStorage.getItem(this.tableSettings.name)) {
                    var filter = JSON.parse(localStorage.getItem(this.tableSettings.name));
                    if(this.tableSettings.name == "preventive-maintenance-job-list-all" && filter['job_status'] && typeof filter['job_status'].value == "string" && filter['job_status'] != this.tableRequest.filter.job_status.value) {
                        filter = {}
                        localStorage.removeItem("preventive-maintenance-job-list-all");
                    }
                    
                    if(Object.keys(filter).length) {
                        for (const [key, val] of Object.entries(filter)) {
                            if(this.tableRequest.filter[key]) {
                            this.tableRequest.filter[key].function = val.function
                            this.tableRequest.filter[key].value    = val.value
                            }
                        }
                        this.actionStatus.showFilter = true;
                    }
                }

                if(is_load_filter && localStorage.getItem(`${this.tableSettings.name}-sort`)) {
                    var sort = JSON.parse(localStorage.getItem(`${this.tableSettings.name}-sort`));
                    if(sort && sort.column && sort.direction) {
                        this.tableRequest.sortColumn    = sort.column
                        this.tableRequest.sortDirection = sort.direction
                    }
                }
                new Promise((resolve, reject) => {
                    this.$emit('load-items', async () => {
                        try {
                            return {
                                tableRequest: this.tableRequest,
                                resolve,
                                reject,
                            }
                        } catch (e) {
                            reject(e)
                        }
                    })
                })
                    .then(data => {
                        this.tableSettings.total = data.total;
                        this.tableSettings.totalPage =  Math.ceil(this.tableSettings.total/ this.tableRequest.limit);
                        this.actionStatus.listLoading = false;
                    })
                    .catch(err => {
                        this.actionStatus.listLoading = false;
                    });
            },
            //--------------------------------------------
            selectAllItems(val){
                if (val) {
                    this.tableSelected.selected = [];
                    for (let i in this.tableItems) {
                        switch (this.tableSettings.name) {
                            case "joblist":
                                if(this.tableItems[i].order_id == null){
                                    this.tableSelected.selected.push(this.tableItems[i].id)
                                }
                                break;
                            case "case-management":
                                if(this.tableItems[i].work_order_id == null){
                                    this.tableSelected.selected.push(this.tableItems[i].id)
                                }
                                break;
                            case "client-contract-asset-management":
                                if(this.tableItems[i].coming_job == null){
                                    this.tableSelected.selected.push(this.tableItems[i].id)
                                }
                                break;
                            case "budget-entries":
                                if(this.HeaderItem.status == 'Draft' || ((this.HeaderItem.status == 'Approved' && this.tableItems[i].entry_type === 'Revision' && this.tableItems[i].month_year[0] && this.tableItems[i].month_year[0].status == 'rev-draft')))
                                    this.tableSelected.selected.push(this.tableItems[i])
                                break;
                            case "property-versioning":
                                if(!this.tableItems[i].is_current){
                                    this.tableSelected.selected.push(this.tableItems[i].id)
                                }
                                break;
                            case "table-incoming-documents":
                                this.tableSelected.selected.push(this.tableItems[i].incoming_document_id)
                                break;
                            case "table-incoming-documents-detail":
                                this.tableSelected.selected.push(this.tableItems[i].incoming_document_id)
                                break;
                            case "safety-app-workers-listing":
                                if(this.tableItems[i].is_add_manual){
                                    this.tableSelected.selected.push(this.tableItems[i].id)
                                }
                                break;
                                break;
                            default:
                                this.tableSelected.selected.push(this.tableItems[i].id)
                                break;
                        }
                    }
                }
                else {
                    this.tableSelected.selected = [];
                }
            },
            prevPage(){
                if(this.tableRequest.page > 1){
                    this.tableRequest.page += -1;
                }
            },
            nextPage(){
                if(this.tableRequest.page < this.tableSettings.totalPage){
                    this.tableRequest.page += 1;
                }
            },
            //---------------------------------------------

            // Table events ---------------------------------------------
            tableItemRowClick(item,index,event){
                if(event.target.className.includes("no-edit") || event.target.parentElement.className.includes("no-edit")){
                    return;
                }
                this.$emit("row-click",item, index);
            },
            tableHeaderClick(key,field){
                if(!field.sorting) return;
                if(this.tableRequest.sortColumn === key){
                    if(this.tableRequest.sortDirection === "ASC"){
                        this.tableRequest.sortDirection = "DESC";
                    }else{
                        this.tableRequest.sortDirection = "ASC";
                    }
                }else{
                    this.tableRequest.sortColumn = key;
                    this.tableRequest.sortDirection = "ASC";
                }

                localStorage.setItem(`${this.tableSettings.name}-sort`, JSON.stringify({
                    column: this.tableRequest.sortColumn,
                    direction: this.tableRequest.sortDirection
                }));
                this.getTableData(true);
            },
            reloadTableItems(){
                this.tableRequest.filter = JSON.parse(JSON.stringify(this.settings.filter));
                if(this.tableRequest.filter.contract_id && this.contractSelector){
                    this.tableRequest.filter.contract_id.value = this.contractSelector.id || null;
                }
                if(this.tableRequest.filter.client_contract_id && this.contractSelector){
                    this.tableRequest.filter.client_contract_id.value = this.contractSelector.id || null;
                }
                if(this.tableRequest.filter.contract_term_id){
                    this.tableRequest.filter.contract_term_id.value = (this.contractSelector && this.contractSelector.contract_terms[0]) ? this.contractSelector.contract_terms[0].id : null;
                }
                //this.tableSettings.total = 0;
                this.tableRequest.page  = 1;

                this.tableSelected.allSelected = false;
                this.tableSelected.selected = [];
                localStorage.removeItem(this.tableSettings.name);
                localStorage.removeItem(`${this.tableSettings.name}-sort`);
                this.getTableData();
                this.$emit("reload-items");
            },
            reloadTableKeepFilter(){
                 this.tableRequest.page  = 1;

                // this.tableSelected.allSelected = false;
                // this.tableSelected.selected = [];
                this.getTableData();
                this.$emit("reload-items");
            },
            createNewTableItem(){
                this.$emit("new-item");
            },
            cloneMaster(){
                this.$emit("clone-master");
            },
            exportCsv(){
                this.$emit("export", this.tableRequest);
            },
            deleteTableItemsComfirm(){
                if(this.tableSelected.selected.length){
                    this.actionStatus.modals.delete.open = true;
                }else{
                    this.$bvToast.toast("Please select a item", {
                        title: 'Notification',
                        autoHideDelay: 2000,
                        variant: 'warning',
                        solid: true
                    });
                }
            },
            deleteTableItems(){
                if(this.actionStatus.modals.delete.loading) return;
                this.actionStatus.modals.delete.loading = true;
                new Promise((resolve, reject) => {
                    this.$emit('delete-items', async () => {
                        try {
                            return {
                                ids: this.tableSelected.selected,
                                filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
                                resolve,
                                reject,
                            }
                        } catch (e) {
                            reject(e)
                        }
                    })
                })
                    .then(data => {
                        this.actionStatus.modals.delete.open = false;
                        this.actionStatus.modals.delete.loading = false;
                        if(data) {
                            this.reloadTableItems();
                            this.$alertNotification(data);
                        }
                    })
                    .catch(err => {
                        this.actionStatus.modals.delete.loading = false;
                        return this.$bvToast.toast("Can't delete items!", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                    })
                ;
            },
            createPWOComfirm(){
                if(this.tableSelected.selected.length){
                    this.actionStatus.modals.createPWO.open = true;
                }else{
                    this.$bvToast.toast("Please select a item", {
                        title: 'Notification',
                        autoHideDelay: 2000,
                        variant: 'warning',
                        solid: true
                    });
                }
            },
            createPWO(){
                this.actionStatus.modals.createPWO.loading = true;
                new Promise((resolve, reject) => {
                    this.$emit('create-pwo', async () => {
                        try {
                            return {
                                ids: this.tableSelected.selected,
                                filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
                                resolve,
                                reject,
                            }
                        } catch (e) {
                            reject(e)
                        }
                    })
                })
                    .then(data => {
                        this.reloadTableItems();
                        this.actionStatus.modals.createPWO.open = false;
                        this.actionStatus.modals.createPWO.loading = false;
                    })
                    .catch(err => {
                        this.actionStatus.modals.createPWO.loading = false;
                    })
                ;

            },
            enableItems(){
                if(this.tableSelected.selected.length){
                    this.$emit("enable-items",this.tableSelected.selected);
                }else{
                    this.$bvToast.toast("Please select a item", {
                        title: 'Notification',
                        autoHideDelay: 2000,
                        variant: 'warning',
                        solid: true
                    });
                }
            },
            adjustmentItems(){
                if(this.tableSelected.selected.length){
                    let filter = this.tableSelected.allItems ? JSON.stringify(this.tableRequest.filter) : null;
                    this.$emit("adjustment-items",this.tableSelected.selected,filter);
                }else{
                    this.$bvToast.toast("Please select a item", {
                        title: 'Notification',
                        autoHideDelay: 2000,
                        variant: 'warning',
                        solid: true
                    });
                }
            },
            assignItems(){
                if(this.tableSelected.selected.length){
                    let filter = this.tableSelected.allItems ? JSON.stringify(this.tableRequest.filter) : null;
                    this.$emit('assign-items',this.tableSelected.selected,filter);
                }else{
                    this.$bvToast.toast("Please select a item", {
                        title: 'Notification',
                        autoHideDelay: 2000,
                        variant: 'warning',
                        solid: true
                    });
                }
            },
            editStatusItemsComfirm(){
                if(this.tableSelected.selected.length){
                    this.actionStatus.modals.changeStatus.open = true;
                }else{
                    this.$bvToast.toast("Please select a item", {
                        title: 'Notification',
                        autoHideDelay: 2000,
                        variant: 'warning',
                        solid: true
                    });
                }
            },
            editStatusItems(){
                if(this.actionStatus.modals.changeStatus.status){
                    this.actionStatus.modals.changeStatus.open = true;
                    this.actionStatus.modals.changeStatus.loading = true;
                    new Promise((resolve, reject) => {
                        this.$emit('edit-status-items', async () => {
                            try {
                                return {
                                    ids: this.tableSelected.selected,
                                    status: this.actionStatus.modals.changeStatus.status,
                                    filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
                                    resolve,
                                    reject,
                                }
                            } catch (e) {
                                reject(e)
                            }
                        })
                    })
                        .then( data => {
                            this.actionStatus.modals.changeStatus.open = false;
                            this.actionStatus.modals.changeStatus.loading = false;
                            this.reloadTableItems();
                        })
                        .catch(err => {
                            this.actionStatus.modals.changeStatus.loading = false;
                        })
                    ;
                }else{
                    this.$bvToast.toast("Please select a status", {
                        title: 'Notification',
                        autoHideDelay: 2000,
                        variant: 'warning',
                        solid: true
                    });
                }
            },
            openImportModal(){
                this.actionStatus.modals.import.open = true;
            },
            importItems(){
                if(this.actionStatus.modals.import.loading) return ;
                if (!this.actionStatus.modals.import.file) {
                    return this.$bvToast.toast("Please choose file to import", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                this.actionStatus.modals.import.loading = true;
                new Promise((resolve, reject) => {
                    this.$emit('import-items', async () => {
                        try {
                            return {
                                file: this.actionStatus.modals.import.file,
                                resolve,
                                reject,
                            }
                        } catch (e) {
                            reject(e)
                        }
                    })
                })
                    .then( data => {
                        this.actionStatus.modals.import.open = false;
                        this.actionStatus.modals.import.loading = false;
                        this.reloadTableItems();
                    })
                    .catch(err => {
                        this.actionStatus.modals.import.loading = false;
                        let msg = "Can't import data!";
                        if( err.response.data.error
                            && err.response.data.error.message
                        ) {
                        msg = err.response.data.error.message;
                        }
                        return this.$alertNotification(msg, "danger");
                    })
                ;
            },
            sendSelectedData(){
                let filter = this.tableSelected.allItems ? JSON.stringify(this.tableRequest.filter) : null;
                this.$emit("get-selected",this.tableSelected.selected,filter);
            },

            // Settings columns ---------------------------------------------
            getColumnSettingByUser(){
                if(this.userLogged.id) {
                    this.tableFields.fields = JSON.parse(JSON.stringify(this.settings.fields));
                    this.tableFields.show = JSON.parse(JSON.stringify(this.settings.fields));
                    this.tableFields.hide = [];
                    this.tableFields._show = JSON.parse(JSON.stringify(this.settings.fields));
                    this.tableFields._hide = [];

                    this.$store.dispatch('AuthController/getColumnSettingsTableUser', {
                        user_id: this.userLogged.id,
                        table_name: this.tableSettings.name
                    }).then(response => {
                        if(response.data.data.hasOwnProperty('code') && response.data.data.code == 404){
                            this.tableFields.show = JSON.parse(JSON.stringify(this.settings.fields));
                            this.tableFields.hide = [];
                            this.tableFields._show = JSON.parse(JSON.stringify(this.settings.fields));
                            this.tableFields._hide = [];
                            return;
                        }
                        if (response.data.data.hasOwnProperty('id')) {
                            this.tableFields.show = response.data.data.settings.show;
                            this.tableFields.hide = response.data.data.settings.hide;
                            this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));
                            this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
                        }
                    }).catch(error => {
                        /*this.tableFields.show = JSON.parse(JSON.stringify(this.settings.fields));
                        this.tableFields.hide = [];
                        this.tableFields._show = JSON.parse(JSON.stringify(this.settings.fields));
                        this.tableFields._hide = [];*/
                    })


                }
            },
            resetColumnFieldsSetting(){
                this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));
                this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
                this.actionStatus.modals.columnSetting.resizeColumn = false;
            },
            hiddenField(item,index){
                item.isActive = 0;
                this.tableFields._hide.push(item);
                this.tableFields._show.splice(index,1);
            },
            shownField(item,index){
                item.isActive = 1;
                this.tableFields._show.push(item);
                this.tableFields._hide.splice(index,1);
            },
            linkToEditColumnWith(){
                this.resetColumnFieldsSetting();
                this.actionStatus.modals.columnSetting.resizeColumn = true;
            },
            saveColumnSettingWithUser(){
                this.actionStatus.modals.columnSetting.loading = true;
                this.tableFields._show.forEach((item, index) => {
                    if(item.width){
                        this.tableFields._show[index].thStyle = "width: " + item.width + "px";
                    }else{
                        this.tableFields._show[index].thStyle = "width: 100px";
                    }
                });

                let data = {
                    fields : this.tableFields.fields,
                    show : this.tableFields._show,
                    hide : this.tableFields._hide,
                };

                this.$store.dispatch('AuthController/updateColumnSettingsUser', {
                    user_id: this.userLogged.id,
                    table_name: this.tableSettings.name,
                    settings: JSON.stringify(data)
                })
                    .then(response => {
                        this.tableFields.show = JSON.parse(JSON.stringify(response.data.data.settings.show));
                        this.tableFields.hide = JSON.parse(JSON.stringify(response.data.data.settings.hide));
                        this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));
                        this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
                        this.actionStatus.modals.columnSetting.open = false;
                        this.actionStatus.modals.columnSetting.resizeColumn = false;
                        this.actionStatus.modals.columnSetting.loading = false;
                    })
                    .catch(err => {
                        this.actionStatus.modals.columnSetting.open = false;
                        this.actionStatus.modals.columnSetting.resizeColumn = false;
                        this.actionStatus.modals.columnSetting.loading = false;
                    })
            },
            updateColumnSettings(field) {
                this.tableFields.show = field;
            },
            //---------------------------------------------

            // Import Data ---------------------------------------------------
            resetImport(){
                this.actionStatus.modals.import.check = '';
                this.actionStatus.modals.import.file = null;
            },
            changeFile(){
                this.actionStatus.modals.import.check = this.actionStatus.modals.import.file ? false : true;
            },
            //----------------------------------------------------------------


            // Import Data ---------------------------------------------------
            setConfig(key,value){
                this.tableSettings[key] = value;
            },
            //----------------------------------------------------------------
            updateCreateBT(){
                this.tableSettings.controls.create = this.settings.controls.create
            },
        }
    }
</script>
